<template lang="pug">
.sms-whatsapp-message-template
  v-row(no-gutters)
    v-col.mr-4
      .title.mb-2
        .text-md.font-medium {{ $t('connect_google_business_page') }}
        .text-sm.neutral700--text.font-normal(v-if="showDescription") {{ $t('connect_google_business_page_description') }}
      .form
        v-form(ref="form")
          v-row(no-gutters)
            //- Subject line
            v-col.mb-8(:cols="cols" :xl="cols - 1")
              v-text-field.text-md.font-normal.my-2.round-xl(v-model="gmbAccountName" :placeholder="$t('google_account')" outlined hide-details readonly prepend-inner-icon="$yzi-google-icon")
                template(#append)
                  v-btn.button-sm.adjust-margin(v-if="hasConnected" color="basic300" depressed :loading="isLoading" @click="nextAction") {{ $t('reconnect') }} 
                  v-btn.button-sm.adjust-margin(v-else color="basic300" depressed @click="nextAction") {{ gmbAccountName ? $t('change') : $t('connect') }}
</template>

<script>

export default {
  name: 'GoogleBusinessPageSetup',
  props: {
    fetchingData: {
      type: Object,
      default: null,
    },
    cols: {
      type: Number,
      default: 5
    },
    showDescription: {
      type: Boolean
    },
    hasConnected: {
      type: Boolean
    },
    appendRightBtn: {
      type: Boolean
    },
    gmbAccountName: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required'],
      },
    }
  },
  methods: {
    nextAction() {
      this.isLoading = true
      if (this.hasConnected) {
        this.$emit('reconnect')
        return
      }
      this.$emit('connectOrChange')
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.no-padding-x {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.selected-button {
  background: #EEEEEE !important;
  border-radius: 16px;
}
::v-deep svg.v-icon.notranslate.v-data-table-header__icon {
  height: 8px !important;
  width: 8px !important;
  margin-left: 8px;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.pre-wrap {
  white-space: pre-wrap;
}
.sticky {
  top: 1%;
  position: sticky;
}
.adjust-margin {
  margin-top: -6px !important;
}
</style>
